import * as yup from "yup";
import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import { getValidationSchema } from "@Shared/utils/validationSchema";
import fitsTableIdentificationFormMeta, { IFitsTableIdentificationFormMeta } from "./IdentificationFormMeta";
import fitTableMaxDigitCheckedFormMeta, { IFitTableMaxDigitsCheckedFormMeta } from "./MaxPinDigitCheckedFormMeta";
import fitTableMaxPinDigitsEntryFormMeta, { IFitTableMaxPinDigitsEntryFormMeta } from "./MaxPinDigitsEntryFormMeta";
import fitTablePanPadFormMeta, { IFitTablePanPadFormMeta } from "./PanPadFormMeta";
import fitTablePinPadFormMeta, { IFitTablePinPadFormMeta } from "./PinPadFormMeta";

export interface IFitsFormMeta extends IFitsTableIdentificationFormMeta, IFitTableMaxDigitsCheckedFormMeta, IFitTableMaxPinDigitsEntryFormMeta, IFitTablePanPadFormMeta, IFitTablePinPadFormMeta {
  
  schema: any;
}

let fitsFormMeta = {} as IFitsFormMeta;

fitsFormMeta = { ...fitsFormMeta, 
  ...fitsTableIdentificationFormMeta, ...fitTableMaxDigitCheckedFormMeta, ...fitTableMaxPinDigitsEntryFormMeta, ...fitTablePanPadFormMeta, ...fitTablePinPadFormMeta
};

fitsFormMeta.schema = yup.object().shape(getValidationSchema(fitsFormMeta));

export default fitsFormMeta;